import { oidcEarlyInit } from "oidc-spa/entrypoint";



const { shouldLoadApp } = oidcEarlyInit({
BASE_URL: "/",

securityDefenses: {



}
});

if (shouldLoadApp) {
import("./app.tsx?oidc-spa-original=true");
}